import React, { useEffect, useState } from 'react';
import { obfuscateEmail } from '../Utils/commonUtil';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const PMU_data = async () => {
    const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/uidai/Contact`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const PMU = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await PMU_data();
                setTabHeading(response_data.heading);
                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, []);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                <br /><br />
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    let report_comp;

    if (reportData == null || reportData.length == 0) {
        report_comp = <>
            <div class="mainhead" align="center">* * *</div>   <br /><br />    <br /><br />
        </>
    } else {
        report_comp = <>  <table align="center" width="60%" border={1}>
            <thead>
                <tr className="tableheader">
                    <th colSpan={17}>{'Contact Details of Technical Support Engineers'}</th>
                </tr>
                <tr className="tableheader">
                    <th>Location</th>
                    <th>Name</th>
                    <th>Mobile Number</th>
                    <th>Email id</th></tr>
            </thead>
            <tbody>
                {reportData.map((item, index) => (
                    <tr key={item.error_code}>
                        <td style={{ textAlign: 'left' }}> {item.location} </td>
                        <td style={{ textAlign: 'left' }}>{item.person_name}</td>
                        <td style={{ textAlign: 'left' }}>{item.mobile}</td>
                        <td style={{ textAlign: 'left' }}>{obfuscateEmail(item.mail)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
        </>
    }


    return (
        <>
            <br /> <br />
            <div class="mainhead" align="center">Toll Free No: 1967 and 18001807011 and 18001807106
            </div>
            {report_comp}
            <br /> <br />
        </>
    );
};

export default PMU;
